import * as actionTypes from '../constants/actionTypes';
import { updateObject } from './../../../../shared/utils';

const initialState = {
  opportunityStages: null,
  opportunityStagesError: null,
  opportunityStagesLoading: false,
  opportunityStageChangeError: null,
  opportunityStageChangeLoading: false,
  deleteOpportunityError: null,
  deleteOpportunityLoading: false,
  opportunityPipelinesControlConfig: null,
  opportunityPipelinesControlConfigError: null,
  opportunityPipelinesControlConfigLoading: false,
  saveOpportunityPipelinesControlConfigError: null,
  saveOpportunityPipelinesControlConfigLoading: false,
};

const getOpportunityPipelinesControlConfigStart = (state, action) => {
  return updateObject(state, {
    opportunityPipelinesControlConfigError: null,
    opportunityPipelinesControlConfigLoading: true,
  });
};

const getOpportunityPipelinesControlConfigSuccess = (state, action) => {
  return updateObject(state, {
    opportunityPipelinesControlConfig: action.opportunityPipelinesControlConfig,
    opportunityPipelinesControlConfigError: null,
    opportunityPipelinesControlConfigLoading: false,
  });
};

const getOpportunityPipelinesControlConfigFail = (state, action) => {
  return updateObject(state, {
    opportunityPipelinesControlConfig: null,
    opportunityPipelinesControlConfigError: action.error,
    opportunityPipelinesControlConfigLoading: false,
  });
};

const saveOpportunityPipelinesControlConfigStart = (state, action) => {
  return updateObject(state, {
    saveOpportunityPipelinesControlConfigError: null,
    saveOpportunityPipelinesControlConfigLoading: true,
  });
};

const saveOpportunityPipelinesControlConfigSuccess = (state, action) => {
  return updateObject(state, {
    saveOpportunityPipelinesControlConfigError: null,
    saveOpportunityPipelinesControlConfigLoading: false,
  });
};

const saveOpportunityPipelinesControlConfigFail = (state, action) => {
  return updateObject(state, {
    saveOpportunityPipelinesControlConfigError: action.error,
    saveOpportunityPipelinesControlConfigLoading: false,
  });
};

const getOpportunityStagesStart = (state, action) => {
  return updateObject(state, {
    opportunityStagesError: null,
    opportunityStagesLoading: true,
  });
};

const getOpportunityStagesSuccess = (state, action) => {
  return updateObject(state, {
    opportunityStages: action.opportunityStages,
    opportunityStagesError: null,
    opportunityStagesLoading: false,
  });
};

const getOpportunityStagesFail = (state, action) => {
  return updateObject(state, {
    opportunityStages: null,
    opportunityStagesError: action.error,
    opportunityStagesLoading: false,
  });
};

const changeOpportunityStageStart = (state, action) => {
  return updateObject(state, {
    opportunityStageChangeError: null,
    opportunityStageChangeLoading: true,
  });
};

const changeOpportunityStageSuccess = (state, action) => {
  return updateObject(state, {
    opportunityStageChangeError: null,
    opportunityStageChangeLoading: false,
  });
};

const changeOpportunityStageFail = (state, action) => {
  return updateObject(state, {
    opportunityStageChangeError: action.error,
    opportunityStageChangeLoading: false,
  });
};

const deleteOpportunityStart = (state, action) => {
  return updateObject(state, {
    deleteOpportunityError: null,
    deleteOpportunityLoading: true,
  });
};

const deleteOpportunitySuccess = (state, action) => {
  return updateObject(state, {
    deleteOpportunityError: null,
    deleteOpportunityLoading: false,
  });
};

const deleteOpportunityFail = (state, action) => {
  return updateObject(state, {
    deleteOpportunityError: action.error,
    deleteOpportunityLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_OPPORTUNITY_PIPELINES_CONTROL_CONFIG_START:
      return getOpportunityPipelinesControlConfigStart(state, action);
    case actionTypes.GET_OPPORTUNITY_PIPELINES_CONTROL_CONFIG_SUCCESS:
      return getOpportunityPipelinesControlConfigSuccess(state, action);
    case actionTypes.GET_OPPORTUNITY_PIPELINES_CONTROL_CONFIG_FAIL:
      return getOpportunityPipelinesControlConfigFail(state, action);

    case actionTypes.SAVE_OPPORTUNITIES_PIPELINES_CONTROL_CONFIG_START:
      return saveOpportunityPipelinesControlConfigStart(state, action);
    case actionTypes.SAVE_OPPORTUNITIES_PIPELINES_CONTROL_CONFIG_SUCCESS:
      return saveOpportunityPipelinesControlConfigSuccess(state, action);
    case actionTypes.SAVE_OPPORTUNITIES_PIPELINES_CONTROL_CONFIG_FAIL:
      return saveOpportunityPipelinesControlConfigFail(state, action);

    case actionTypes.GET_OPPORTUNITIES_STAGES_START:
      return getOpportunityStagesStart(state, action);
    case actionTypes.GET_OPPORTUNITIES_STAGES_SUCCESS:
      return getOpportunityStagesSuccess(state, action);
    case actionTypes.GET_OPPORTUNITIES_STAGES_FAIL:
      return getOpportunityStagesFail(state, action);

    case actionTypes.CHANGE_OPPORTUNITY_STAGE_START:
      return changeOpportunityStageStart(state, action);
    case actionTypes.CHANGE_OPPORTUNITY_STAGE_SUCCESS:
      return changeOpportunityStageSuccess(state, action);
    case actionTypes.CHANGE_OPPORTUNITY_STAGE_FAIL:
      return changeOpportunityStageFail(state, action);

    case actionTypes.DELETE_OPPORTUNITY_START:
      return deleteOpportunityStart(state, action);
    case actionTypes.DELETE_OPPORTUNITY_SUCCESS:
      return deleteOpportunitySuccess(state, action);
    case actionTypes.DELETE_OPPORTUNITY_FAIL:
      return deleteOpportunityFail(state, action);
    default:
      return state;
  }
};

export default reducer;
